import { AmplitudeClient } from 'amplitude-js';
import { releaseEnv } from '@algoan/dashboard/env';

export enum AmplitudeEvent {
  ACCOUNT_SELECTION_COMPLETED = 'account_selection_completed',
  ACCOUNT_SELECTION_ERROR = 'account_selection_error',
  ACCOUNT_SELECTION_STARTED = 'account_selection_started',
  ANALYSE_CHANGE_STATUS = 'analyse_change_status',
  ANALYSE_CHECK_REMAIN_TO_LIVE = 'analyse_check_remain_to_live',
  ANALYSE_COMPUTE_NEW_LOAN = 'analyse_compute_new_loan',
  ANALYSE_DOWNLOAD = 'analyse_download',
  ANALYSE_UNCHECK_REMAIN_TO_LIVE = 'analyse_uncheck_remain_to_live',
  LINK_COPY = 'link_copy',
  LINK_START = 'link_start',
  LOGIN_AUTO_DISCONNECT = 'login_auto_disconnect',
  LOGIN_BAD = 'login_bad',
  LOGIN_DISCONNECT = 'login_disconnect',
  LOGIN_FAIL = 'login_fail',
  LOGIN_SUCCESS = 'login_success',
  NAVIGATION_DOWNLOAD = 'navigation_download',
  NAVIGATION_DOWNLOAD_ALL = 'navigation_download_all',
  NAVIGATION_FILTER = 'navigation_filter',
  NAVIGATION_REFRESH = 'navigation_refresh',
  NAVIGATION_SELECT = 'navigation_select',
  CASHFLOW_OPEN = 'cashflow_open',
  CASHFLOW_CHANGE = 'cashflow_change',
  CASHFLOW_SUCCESS = 'cashflow_success',
  CASHFLOW_ERROR = 'cashflow_error',
  CASHFLOW_DENIED = 'cashflow_denied',
  TRANSACTION_SELECT_DATE = 'transaction_select_date',
  TRANSACTION_ADD_COMMENT = 'transaction_add_comment',
  NAVIGATION_CLOSE_APPLICATION = 'navigation_close_application',
  ANALYSE_SEND_PARTNER = 'analyse_send_partner',
  NEW_WINDOW_WIDGET_OPEN = 'new_window_widget_open',
  NEW_WINDOW_WIDGET_COMPLETED = 'new_window_widget_completed',
  FEEDBACK = 'feedback',
  HAS_PROJECTID_EQUAL_ASTERISK = 'has_projectid_equal_asterisk',
  ADD_NOTE = 'add_note',
}

export interface UserIdentity {
  userId: string;
  chatflowIds?: string;
  projectIds?: string;
  organizationIds?: string;
  env?: string;
}

const getAmplitude = (): AmplitudeClient => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  return require('amplitude-js').default.getInstance();
};

// ## TODO : faire dynamic import with store
export const logAmplitudeEvent = (eventName: AmplitudeEvent, eventData?: Record<string, unknown>): void => {
  getAmplitude().logEvent(eventName, eventData);
};

// This will add the user identity to every following event
export const attachUserIdentityToAmplitude = (userIdentity: UserIdentity): void => {
  const { userId, chatflowIds, projectIds, organizationIds, env } = userIdentity;
  getAmplitude().setUserId(userId);
  getAmplitude().setUserProperties({ chatflowIds, organizationIds, projectIds, env });
};

// This will remove the user identity from every following event
export const removeUserIdentityFromAmplitude = (): void => {
  getAmplitude().clearUserProperties();
  getAmplitude().setUserId(null);
  getAmplitude().regenerateDeviceId();
};

// This will add the environment to the user properties. To be used when the rest of the user is undefined (ie: login failure)
export const attachEnvironmentToAmplitude = (): void => {
  getAmplitude().setUserProperties({ env: releaseEnv });
};
